import { createCommand } from '@commander-js/extra-typings';
import type { CommandServices } from '@wix/cli-command-contract';
import React from 'react';
import { validateDocsExtensionType } from './validations.js';

export const generateCommand = (
  services: CommandServices,
  cliVersion: string
) => {
  return createCommand('generate')
    .description('Generate a new extension for your project')
    .option(
      '--type <type>',
      'Extension type to generate',
      validateDocsExtensionType
    )
    .action(async (options, command) => {
      const { GenerateCommand } = await import(
        '../components/GenerateCommand/index.js'
      );
      const { renderCommand } = await import('./render-command.js');
      const { type } = options;
      await renderCommand(
        command,
        services,
        cliVersion,
        <GenerateCommand docsExtensionType={type} />
      );
    });
};
